'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdMicOff = function MdMicOff(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm7.1 5l27.9 27.9-2.1 2.1-7-7c-1.2 0.8-2.8 1.3-4.3 1.5v5.5h-3.2v-5.5c-5.5-0.8-10-5.4-10-11.1h2.8c0 5 4.2 8.4 8.8 8.4 1.3 0 2.7-0.3 3.8-0.9l-2.7-2.7c-0.3 0.1-0.7 0.2-1.1 0.2-2.7 0-5-2.3-5-5v-1.3l-10-10z m17.9 13.6l-10-9.9v-0.3c0-2.8 2.3-5 5-5s5 2.2 5 5v10.2z m6.6-0.2c0 1.9-0.5 3.8-1.4 5.4l-2.1-2.1c0.5-1 0.7-2.1 0.7-3.3h2.8z' })
        )
    );
};

exports.default = MdMicOff;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/mic-off.js
// module id = 3099
// module chunks = 0